var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17v-2h2V8c0-1.383.417-2.612 1.25-3.688C4.083 3.237 5.167 2.534 6.5 2.2v-.7c0-.417.146-.77.438-1.063A1.447 1.447 0 018 0c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v.7c1.333.333 2.417 1.037 3.25 2.112C13.583 5.388 14 6.617 14 8v7h2v2H0zm8 3c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 016 18h4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 018 20zm-4-5h8V8c0-1.1-.392-2.042-1.175-2.825C10.042 4.392 9.1 4 8 4s-2.042.392-2.825 1.175C4.392 5.958 4 6.9 4 8v7z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPerson);
export default __webpack_public_path__ + "static/media/notification-person.c35691c8fb550584548334c2ff705afd.svg";
export { ForwardRef as ReactComponent };